import _asyncToGenerator from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/regenerator/index.js";
var select = require('select');

// eslint-disable-next-line import/no-mutable-exports
var copyToClipboard;

// NOTE: navigator can not be used directly, because Gatsby would not be able to build (sees it as an undefined global variable).
// That is why wee need to wrap it with the next function
(function (win) {
  var textAreaElement,
    killFocus = true;
  var navigator = win.navigator,
    doc = win.document,
    navClipboardSupport = navigator && navigator.clipboard,
    // check navigator first, otherwise Gatsby build will fail
    canPolyfill = !!doc && typeof doc.execCommand === 'function'; // also check doc, otherwise Gatsby build will fail

  // If no clibboard support, then create a hidden textarea element as fallback
  // we keep i in the dom for re-usage
  if (!navClipboardSupport && canPolyfill && doc) {
    // also check doc, otherwise Gatsby build will fail
    textAreaElement = doc.createElement('textarea');
    // make sure no one sees it and it doesn't disturb scroll feature
    var style = textAreaElement.style;
    style.top = '-100px';
    style.left = '-100px';
    style.zIndex = '-100';
    style.height = '1px';
    style.width = '1px';
    style.position = 'absolute';
    doc.body.appendChild(textAreaElement);
  }

  /**
   * Returns an Intl object for a specific locale.
   * Creates maximum 1 instance per locale: uses internal cache.
   *
   * @function copyToClipboard
   * @param {string} text - The text to be copied to the clipboard
   * @return {Boolean} "true" when successfully copied the text to the clipboard; "false" otherwise
   * @since 0.1.1
   */
  copyToClipboard = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(text) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!navClipboardSupport) {
              _context.next = 11;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return navigator.clipboard.writeText(text);
          case 4:
            return _context.abrupt("return", true);
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0.message);
            return _context.abrupt("return", false);
          case 11:
            if (canPolyfill) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", false);
          case 13:
            // h4x0r
            if (killFocus) {
              textAreaElement.style.top = window.pageYOffset + 'px';
              killFocus = false;
            }
            textAreaElement.innerText = text;
            select(textAreaElement);
            return _context.abrupt("return", doc.execCommand('copy'));
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7]]);
    }));
    return function copyToClipboard(_x) {
      return _ref.apply(this, arguments);
    };
  }();
})(typeof global !== 'undefined' ? global : /* istanbul ignore next */this);
export default copyToClipboard;